module.exports = __webpack_public_path__ + "static/organic-search-row-six-hero-3-ea8e2dd1547275ee45b3d2ae1bbdec72.png";